import React from "react";
import { Box } from "@chakra-ui/react";
import CmsPageTitle from "@/utils/CmsPageTitle";
import ContainerBox from "@/utils/ContainerBox";

const Terms = () => {
  return (
    <Box>
      <CmsPageTitle title="Terms and conditions" />
      <ContainerBox bgColor="bg-gray" Style=" gap-4 sm:gap-8">
        <Box className="container mx-auto">
          <Box className="py-4">
            <p className="mb-3">SkilSoar is owned and operated by SkilSoar Technologies LLC, registered in the State of Texas.
            </p>
            <h4 className="heading-color mb-2">Terms of Use</h4>
            <p className="mb-3">
              By accessing or using SkilSoar, you agree to our Terms of Service, which govern:
            </p>
            <ul style={{ listStyleType: "disc" }}>
              <li>User responsibilities and conduct</li>
              <li>Session payment terms and refund policy</li>
              <li>Intellectual property rights</li>
              <li>Dispute resolution and limitation of liability</li>
            </ul>
            <p className="mb-3">
              All users are responsible for ensuring their actions on the platform comply with local laws and professional standards.
            </p>
            <Box className="mt-4">
              <h4 className="heading-color mb-2">Payment Terms</h4>
              <ul style={{ listStyleType: "disc" }}>
                <li>All transactions are processed through Stripe.</li>
                <li>SkilSoar retains a platform fee from each session.</li>
                <li>Taxes may apply based on user location and applicable law.</li>
              </ul>
            </Box>
            <p className="mb-3">
              Intellectual Property
            </p>
            <p className="mb-3">
              All content, branding, and platform code are the property of SkilSoar Technologies LLC and may not be copied or reused without permission.
            </p>
            <p className="mb-3">
              Legal Jurisdiction
            </p>
            <p className="mb-3">
              This site is governed by the laws of the State of Texas. Any legal disputes will be resolved in the courts of Texas.
            </p>
            {/* <Box className="mt-4">
              <h4 className="heading-color mb-2">2. Services Provided</h4>
              <p>Skill Sour connects individuals ("Instructors") who offer skill-based sessions with other users ("Participants") seeking to learn. The Platform allows Instructors to set up sessions, and Participants to book and attend these sessions.</p>
            </Box>
            <Box className="mt-4">
              <h4 className="heading-color mb-2">3. Session Bookings and Payments</h4>
              <p>Instructors may set their pricing and availability for sessions. Participants are required to make payments through the Platform.</p>
              <p>Skill Sour charges a service fee for facilitating the connection between Instructors and Participants. The fee will be deducted from the payment made by the Participant.</p>
              <p>All payments are processed securely through third-party payment processors.</p>
            </Box> */}
          </Box>
        </Box>
      </ContainerBox>
    </Box>
  );
};

export default Terms;